export const isNotNull = <T extends any>(e: T | null): e is T => e !== null;
